import { insertDatasetBetween } from 'js/actions';
import PopUpForm from 'js/components/elements/pop-up-form/PopUpForm';
import { TextareaAutosize } from 'js/components/pipelines/cards/components/TextareaAutosize';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { Stack } from 'new/elements/Stack';
import React from 'react';
import { useSelector } from 'react-redux';
import { NodeBox } from '../components/NodeBox';
import { ResourceName } from '../components/ResourceName';
import classes from './QueryRewriter.module.scss';
import useAiContainers from 'js/components/pipelines/cards/hooks/useAiContainers';
import { useDraftContext } from 'new/components/flows/types/genai_rag/context/Draft/useDraftContext';

interface QueryRewriterProps {
  data: any;
}

const rewriterFields = {
  rewriter_type: {
    name: 'rewriter_type',
    display_name: '',
    type: 'string',
    inputType: 'select',
    unsorted: true,
    options: [
      {
        label: 'Custom Rewriter',
        value: 'custom',
        description: 'Create your own rewriter',
      },
    ],
  },
  rewriter_name: {
    name: 'rewriter_name',
    display_name: 'Name',
    placeholder: 'Name for your custom rewriter',
    type: 'string',
    inputType: 'text',
    dependsOn: {
      name: 'rewriter_type',
      value: 'custom',
    },
    default: '',
  },
  rewriter_code: {
    name: 'rewriter_code',
    display_name: 'Setup',
    type: 'string',
    inputType: 'code',
    default: 'custom_query_rewriter = "Prompt goes here"',
    fieldProps: {
      language: 'python',
      modalTitle: 'Custom Query Rewriter',
    },
    dependsOn: {
      name: 'rewriter_type',
      value: 'custom',
    },
  },
};

export const QueryRewriter = (props: QueryRewriterProps) => {
  const { data } = props;
  const { id, origin_node_id, code_container_id, children } = data;
  const dispatch = useAppDispatch();
  const { isEdit } = useDraftContext();

  const type = 'query_rewriter';

  const { formData, fields, onFieldUpdated } = useAiContainers(data, rewriterFields, type);
  const queryResponse = useSelector(
    (state: any) =>
      (Object.values(state.rag.queryResponse[origin_node_id] || {})[0] as any)?.query_rewriter,
  );
  const childDataSetId = useSelector(
    (state: any) => state.entities.flowNodes[children?.[0]]?.data_set_id,
  );

  const onAddChild = () => {
    // insert a new data set between this node and its child
    dispatch(
      insertDatasetBetween(id, childDataSetId, {
        custom_config: { node_type: 'query_rewriter' },
      }),
    );
  };

  return (
    <NodeBox data={data} className={classes.container}>
      <ResourceName {...props} hideActions>
        QUERY REWRITER
      </ResourceName>
      {/* TODO: commenting this out until we support inserting nodes */}
      {/* <ActionMenu>
        <ActionItem onClick={onAddChild}>Add Query Rewriter</ActionItem>
      </ActionMenu> */}
      <div className={classes.queryPromptContainer}>
        <Stack className={classes.stack}>
          <PopUpForm
            rootClassName={isEdit ? 'nodrag nowheel' : undefined}
            data={formData}
            fields={fields}
            onFieldUpdated={onFieldUpdated}
          />
          {queryResponse && (
            <>
              <NodeBox.Title>Result</NodeBox.Title>
              <TextareaAutosize readOnly value={queryResponse} />
            </>
          )}
        </Stack>
      </div>
    </NodeBox>
  );
};
